export default function columnizeDates(dates) {
  if (!dates) return '--';
  let sorted_dates = [...dates]
  sorted_dates.sort((a,b) => a.localeCompare(b))
  return sorted_dates.join('<br />');
}